//  export const api_url = "http://tizr.alcax.com:9000";
// export const api_url = "http://localhost:9000";

export const api_url = "https://backend.tizr.app";